module.exports = __webpack_public_path__ + "img/pressstart.5cd074ab.png";